"use strict";
var breadcrumbs_controller_1 = require("./breadcrumbs.controller");
var templateUrl = require("./breadcrumbs.html");
exports.breadcrumbs = {
    templateUrl: templateUrl,
    controller: breadcrumbs_controller_1.BreadcrumbsController,
    controllerAs: "vm",
    bindToController: true,
    scope: {
        crumbs: "="
    }
};



/** WEBPACK FOOTER **
 ** ./app/common/breadcrumbs/breadcrumbs.ts
 **/